import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Grid, Modal, Typography, TextField, Autocomplete, Chip, Stack } from "@mui/material";

import { Button, Alert } from "../../../common/styled";
import ModalBox from "../../../../common/ModalBox";

import useLLMConfig from "../../../../../hooks/user/useLLMConfig";

function BanTopicsModal({ open, handleClose, zoneUid }) {
  const { llmOutputScanners, configLLMSettingOutputScanners } = useLLMConfig();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        topics: llmOutputScanners ? llmOutputScanners?.ban_topics?.topics : [],
        threshold: llmOutputScanners ? llmOutputScanners?.ban_topics?.threshold : 0,
      }}
      validationSchema={Yup.object().shape({
        topics: Yup.array().of(Yup.string()),
        threshold: Yup.number().min(0, "Threshold must be at least 0").max(1, "Threshold must be at most 1"),
      })}
      onSubmit={async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        try {
          values.submit = undefined;
          await configLLMSettingOutputScanners(zoneUid, "ban_topics", values);
          handleClose();
          resetForm();
        } catch (error) {
          const message = error.message || "Something went wrong";
          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleChange, handleSubmit, setFieldValue, isSubmitting, touched, values }) => (
        <React.Fragment>
          <Modal
            open={open}
            onClose={(_, reason) => {
              if (reason !== "backdropClick") {
                handleClose();
              }
            }}
          >
            <ModalBox sx={{ width: "60vw" }} title="Edit Ban Topics Scanner" handleClose={handleClose}>
              <form noValidate onSubmit={handleSubmit}>
                <Grid container p={4} spacing={3}>
                  <Grid item xs={12}>
                    {errors.submit && (
                      <Alert mt={2} mb={3} variant="outlined" severity="error">
                        {errors.submit}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Threshold</Typography>
                      <TextField
                        fullWidth
                        name="threshold"
                        type="number"
                        error={Boolean(touched.threshold && errors.threshold)}
                        helperText={touched.threshold && errors.threshold}
                        value={values.threshold}
                        onBlur={(e) => {
                          if (e.target.value === "") setFieldValue("threshold", 0);
                        }}
                        onChange={handleChange}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack direction="column" spacing={2} alignItems="flex-start">
                      <Typography>Topics</Typography>
                      <Autocomplete
                        fullWidth
                        multiple
                        freeSolo
                        name="topics"
                        options={[]}
                        value={values.topics}
                        error={Boolean(touched.topics && errors.topics)}
                        helperText={touched.topics && errors.topics}
                        onChange={(event, newValue) => setFieldValue("topics", newValue)}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => <Chip variant="filled" color="warning" label={option} {...getTagProps({ index })} />)
                        }
                        renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Type and press Enter" />}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} textAlign={"right"} pt={4}>
                    <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
                      <Button variant="outlined" color="secondary" size="modal" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button type="submit" variant="contained" color="success" size="modal" disabled={isSubmitting}>
                        Save
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </form>
            </ModalBox>
          </Modal>
        </React.Fragment>
      )}
    </Formik>
  );
}

export default BanTopicsModal;
